import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "../store"

export interface UserDetails {
  contactNumber: string
  createdAt: string
  email: string
  id: string
  isActive: boolean
  name: string
  profilePicture: string
  updatedAt: string
  countryPrefix: string
  adminType: "Super" | "CustomerCare" | "Accountant"
  // RBAC fields from OTP verification response
  roleId?: string
  roleName?: string
  permissions?: string[]
}
export interface initialAppState {
  userDetails: UserDetails | undefined | any
  isLoading?: boolean
  /** True once the profile API has responded (success OR error). */
  profileLoaded: boolean
}
const initialState: initialAppState = {
  userDetails: undefined,
  isLoading: false,
  profileLoaded: false,
}

export const signedInUserDetailsSlice = createSlice({
  name: "signedInUserDetails",
  initialState,

  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload
      state.profileLoaded = true
    },
    setProfileLoaded: (state) => {
      state.profileLoaded = true
    },
  },
})

export const { setUserDetails, setProfileLoaded } = signedInUserDetailsSlice.actions

export const signedInUserDetailsState = (state: RootState) => state.signedInUserDetails

export default signedInUserDetailsSlice.reducer
